import { render, staticRenderFns } from "./SlideMenu.vue?vue&type=template&id=6288a210&scoped=true"
import script from "./SlideMenu.vue?vue&type=script&lang=js"
export * from "./SlideMenu.vue?vue&type=script&lang=js"
import style0 from "./SlideMenu.vue?vue&type=style&index=0&id=6288a210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6288a210",
  null
  
)

export default component.exports